import { render, staticRenderFns } from "./ProjectTickets.vue?vue&type=template&id=3435ce8a&lang=html"
import script from "./ProjectTickets.vue?vue&type=script&lang=js"
export * from "./ProjectTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports